import { render } from "./ProfessionalList.vue?vue&type=template&id=67019834&scoped=true&ts=true"
import script from "./ProfessionalList.vue?vue&type=script&lang=ts"
export * from "./ProfessionalList.vue?vue&type=script&lang=ts"

import "./ProfessionalList.vue?vue&type=style&index=0&id=67019834&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67019834"]])

export default __exports__